import { createAction } from 'typesafe-actions';

export const settingsShowSilentArtists = createAction(
  'settings/artists/show/silent',
)();
export const settingsHideSilentArtists = createAction(
  'settings/artists/hide/silent',
)();
